import { queryOptions, useQuery } from "@tanstack/react-query";
import { neWebApi } from "../../../../api";
import { neWebQueryKeys, neWebUrls } from "../../../../ne-web-urls";
import type {
  PPAInvoiceDrift,
  PPADeliveryInvoiceDriftsResponse
} from "../PPAInvoicePage.types";

export const ppaDeliveryInvoiceDriftsQueryOptions = queryOptions({
  queryKey: neWebQueryKeys.ppaInvoicing.invoiceDrifts(),
  queryFn: fetchPPADeliveryInvoiceDrifts
});

async function fetchPPADeliveryInvoiceDrifts(): Promise<
  Map<string, PPAInvoiceDrift>
> {
  const url = neWebUrls.api.ppaDirectDeliveryInvoiceDriftDetection();
  const response = await neWebApi.get<PPADeliveryInvoiceDriftsResponse>(url);

  return new Map(response.data.map((drift) => [drift.invoice_id, drift]));
}

export function usePPADirectDeliveryInvoiceDrifts() {
  return useQuery(ppaDeliveryInvoiceDriftsQueryOptions);
}
